import { render } from "./shopVue.vue?vue&type=template&id=6d5e7c08"
import script from "./shopVue.vue?vue&type=script&lang=js"
export * from "./shopVue.vue?vue&type=script&lang=js"

import "./shopVue.vue?vue&type=style&index=0&id=6d5e7c08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__